import { TaskOpportunityTarget } from "@/store/task-management/utils/types/types";

export const isTaskOpportunityTarget = (
  target: any,
): target is TaskOpportunityTarget => {
  return !!target?.action_type;
};
